import React, { useContext } from 'react';

import { setGenericEvent } from 'features/tealium/ga4/custom';
import ProductCheckableListItem from 'features/product/components/ProductCheckableListItem';

import { FrequentlyBoughtTogetherContext } from '../context';

import './FrequentlyBoughtTogetherProductList.scss';

function FrequentlyBoughtTogetherProductList () {

	const {
		products, mainShortSku, selectProduct, deselectProduct
	} = useContext(FrequentlyBoughtTogetherContext);
	const styles = { '--numOfProducts': products.length } as React.CSSProperties;

	function handleProductSelect (e: React.ChangeEvent<HTMLInputElement>, product: LP.product.ProductItem) {

		if (e.target.checked) {

			selectProduct(product);
			setGenericEvent({
				event_name: 'pdp_fbt_select',
				pdp_item_id: mainShortSku,
				pdp_prime_cat: window.utag_data.product_category[0],
				fbt_item_info: product.ShortSku
			});

		} else {

			deselectProduct(product.ShortSku);
			setGenericEvent({
				event_name: 'pdp_fbt_unselect',
				pdp_item_id: mainShortSku,
				pdp_prime_cat: window.utag_data.product_category[0],
				fbt_item_info: product.ShortSku
			});

		}

	}

	return (
		<div className="FrequentlyBoughtTogetherProductList" style={styles}>
			{products.map((product) => (
				<ProductCheckableListItem
					key={product.ShortSku}
					product={product}
					name="fbtProduct"
					formId={crypto.randomUUID()}
					skipMainProductSkuView
					imageSize={274}
					onChange={(e) => handleProductSelect(e, product)}
					onClick={() => {

						setGenericEvent({
							event_name: 'pdp_fbt_click',
							pdp_item_id: mainShortSku,
							pdp_prime_cat: window.utag_data.product_category[0],
							fbt_item_info: product.ShortSku
						});

					}}
				/>
			))}
		</div>
	);

}

export default FrequentlyBoughtTogetherProductList;
